import Layout from "../../components/layout/Layout";
import Loader from "../../components/Loader";
import Pagination from "../../components/pagination";
import useGetEmployeeGratuityList from "../../hooks/gratuity/useGetEmployeeGratuityList";
import { useState, useRef } from "react";
import { debounce } from "lodash";

const EmployeeGratuityListing = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const {
    gratuityList,
    isLoading,
    paginationData,
    onPageChange,
    setGetListParams,
  } = useGetEmployeeGratuityList();

  // Create debounced search function
  const debouncedOnSearch = useRef(
    debounce((val) => {
      setGetListParams((prev) => ({
        ...prev,
        search_query: val,
        page_number: 0,
      }));
    }, 300)
  ).current;

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    debouncedOnSearch(value);
  };

  return (
    <Layout>
      <div className="px-5">
        <div className="flex flex-col gap-3 mt-5 mb-6">
          <h1 className="text-2xl font-semibold roboto">
            Gratuity for employees
          </h1>
          <input
            type="search"
            placeholder="Search by name"
            value={searchQuery}
            onChange={handleSearch}
            className="max-w-[500px] px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-color1"
          />
        </div>

        {!isLoading && (
          <div className="overflow-auto">
            <table class="table-auto w-full text-sm">
              <thead>
                <tr className="bg-[color:var(--color1)] text-center">
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 w-[18%]">
                    Employee Name
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 w-[10%]">
                    Date of joining
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 w-[10%]">
                    Last working date
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 w-[6%]">
                    Eligible
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 ">
                    Present Days
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 ">
                    Absent Days
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 ">
                    Total Leaves
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 ">
                    No of working days
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 ">
                    Tenure years
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 ">
                    Gross salary
                  </th>
                  <th className="font-semibold text-white py-3 lg:py-3 px-3 lg:px-4 ">
                    Gratuity amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {gratuityList.map((item, index) => {
                  const {
                    name,
                    date_of_joining,
                    last_working_date,
                    eligible_status,
                    present_days,
                    absent_days,
                    total_leaves,
                    no_of_working_days,
                    tenure_years,
                    gross_salary,
                    gratuity_amount,
                  } = item;
                  return (
                    <tr key={index}>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {name}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {date_of_joining}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {last_working_date}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {eligible_status}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {present_days}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {absent_days}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {total_leaves}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {no_of_working_days}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {tenure_years}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {gross_salary}
                      </td>
                      <td class="text-center text-dark font-medium py-3 px-2 bg-[#F3F6FF] border-b border-l border-[#E8E8E8]">
                        {gratuity_amount}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {isLoading && (
          <div className="grid place-items-center pt-40 pb-20">
            <Loader className={"!text-black w-16 h-16"} />
          </div>
        )}

        <div className="grid place-items-center mt-4 mb-8">
          <Pagination
            currentPage={paginationData.page_no}
            lengthofItems={paginationData.total_count}
            limit={paginationData.per_page}
            onPageChange={onPageChange}
          />
        </div>
      </div>
    </Layout>
  );
};

export default EmployeeGratuityListing;
